// src/utils/varmetabModel.js
import constructionTypesJson from '../data/constructionTypes.json';
import linjetabTypesJson from '../data/linjetabTypes.json';

export const PLAN_TYPES = constructionTypesJson.constructionTypes ?? constructionTypesJson;
export const LINE_TYPES = linjetabTypesJson.linjetabTypes ?? linjetabTypesJson;

export const KIND = { PLAN: 'plan', LINE: 'line' };
export const REF_COL = { helårs: 'Udefault', sommer: 'UdefaultSummer' };

export const getRefU = (item, bType = 'helårs') =>
    item?.[REF_COL[bType]] ?? item?.Udefault ?? null;

/** Make a fresh row with sensible defaults */
export function makeRow(kind = KIND.PLAN) {
    const src = kind === KIND.LINE ? LINE_TYPES : PLAN_TYPES;
    const first = src[0] ?? { tInd: 20, tUde: -12 };
    return {
        id: crypto.randomUUID(),
        partKind: kind,
        bygningsdel: '',
        comment: '',
        typeKey: null,
        UorPsi: 0,
        AorL: 0,
        Ti: first.tInd ?? 20,
        Te: first.tUde ?? -12,
        maxVal: null,
    };
}

/** Clone rows and set U/Ψ + maxVal from reference table for current building type */
export function cloneRowsWithRef(rows = [], bType = 'helårs') {
    return rows.map(r => {
        const base = structuredClone(r);
        const list = r.partKind === KIND.LINE ? LINE_TYPES : PLAN_TYPES;
        const src = list[r.typeKey ?? -1];
        const ref = getRefU(src, bType);
        return { ...base, UorPsi: ref ?? 0, maxVal: ref ?? null };
    });
}

export const isAutoRow = r => typeof r?.id === 'string' && r.id.startsWith('__extra');
export const stripAutoRows = rows => (Array.isArray(rows) ? rows.filter(r => !isAutoRow(r)) : []);

/** Sum glass area by name or by type indices (windows, doors w/ glass, skylights, domes) */
const GLASS_RE = /(vinduer|yderdør|yderdøre|ovenlys|kupler)/i;
const GLASS_TYPE_INDICES = new Set(
    PLAN_TYPES
        .map((t, i) =>
            /^(vinduer|ovenlysvinduer?|ovenlyskupler?|yderdøre?\s*med\s*glas)$/i.test(t.name) ? i : -1
        )
        .filter(i => i >= 0)
);

export function sumGlassArea(rows = []) {
    return rows.reduce((sum, r) => {
        if (!r?.AorL) return sum;
        const name = (r.bygningsdel || PLAN_TYPES[r.typeKey ?? -1]?.name || '').toLowerCase();
        if (GLASS_RE.test(name)) return sum + Number(r.AorL);
        if (r.typeKey != null && GLASS_TYPE_INDICES.has(r.typeKey)) return sum + Number(r.AorL);
        return sum;
    }, 0);
}
